import React from 'react';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import {
  CircularProgress
} from '@material-ui/core';

import Create from './Create';
import CommentItem from './CommentItem';
import {
  fetchCommentsOfDecision
} from '../../../api/managerialDecision/managerialDecisionComment.api';
import { addAlert } from '../../../actions/alerts.action';

const Comments = ({ managerialDecisionId }) => {
  const dispatch = useDispatch();

  const commentsQuery = useQuery(
    [ 'managerialDecisionComments', managerialDecisionId ],
    async () => {
      const { data } = await fetchCommentsOfDecision(managerialDecisionId);
      return data;
    },
    {
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  const comments = commentsQuery.data;

  return (
    <>
      { !comments && <CircularProgress/>}
      { comments && comments.length !== 0 &&
        <>
          {comments.map(comment => (
            <CommentItem
              comment={ comment }
              managerialDecisionId={ managerialDecisionId }
              key={ comment.id }
            />
          ))}
        </>
      }
      <Create managerialDecisionId={ managerialDecisionId } />
    </>
  );
};

export default Comments;